import { quickFetchOrGet } from '../../utils/ajaxUtils';
import { ACADEMY_CATALOG_SERVICE_URI } from '../../constants/ApiConstants';
import { dataFetchingClient } from '../../utils/DataFetchingClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { Set as ImmutableSet } from 'immutable';
import { useMemo } from 'react';
const GET_FILTERS = registerQuery({
  fieldName: 'filters',
  args: [],
  fetcher() {
    return quickFetchOrGet('academy-filters', `${ACADEMY_CATALOG_SERVICE_URI}/filters`);
  }
});
export const getFilters = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_FILTERS
  });
};
export const useFilters = () => {
  const {
    data: filters,
    loading: filtersLoading,
    error: filtersError
  } = useQuery(GET_FILTERS);
  return {
    filters,
    filtersLoading,
    filtersError
  };
};
export const useImmutableFilters = () => {
  const {
    filters: filtersResponse,
    filtersLoading,
    filtersError
  } = useFilters();
  const filters = useMemo(() => {
    var _filtersResponse$subC, _filtersResponse$hsSo, _filtersResponse$leve;
    return {
      subCategories: ImmutableSet((_filtersResponse$subC = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.subCategories) !== null && _filtersResponse$subC !== void 0 ? _filtersResponse$subC : []),
      hsSoftwareFilters: ImmutableSet((_filtersResponse$hsSo = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.hsSoftwareFilters) !== null && _filtersResponse$hsSo !== void 0 ? _filtersResponse$hsSo : []),
      levelFilters: ImmutableSet((_filtersResponse$leve = filtersResponse === null || filtersResponse === void 0 ? void 0 : filtersResponse.levelFilters) !== null && _filtersResponse$leve !== void 0 ? _filtersResponse$leve : [])
    };
  }, [filtersResponse]);
  return {
    filters,
    filtersLoading,
    filtersError
  };
};